import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import UnderConstruction from "../container/Blank/UnderConstruction";

// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Accommodation = () => {
  const show =false;
  if (show) {

    return (
      <React.Fragment>
        <SEO title="Accommodation | DMBD 2025" />
        <Header />
        <Breadcrumb
          image="images/bg/banner2.jpg"
          title="Accommodation"
          content="For Participants"
          contentTwo="Accommodation"
          linkage="/"
        />

        {/* <HomeAbout /> */}
        <EmptyTwo>
          <div className="entry-content">
            <h3 align="center" >
              Reserving a Room at Venue Hotel{" "}-- 
              <a href="https://saigon.newworldhotels.com/en/">
              New World Saigon Hotel
                {" "}
              </a> !
            </h3>
            <hr></hr>
            <h4>We have negotiated rate rooms available for attendees, <a href="./reservation">click here</a></h4>
            <hr></hr>
            {/* <br></br> */}
            {/* <p align="left">
              一些酒店信息 未修改
              <br />
              1. All participants are highly recommendated to make a reservation
              at Qingdao Blue Horizon Hotel Laoshan in Qingdao.
              <br />
              2.Considering July is a tourism-peak season of Qingdao, it&apos;s
              may hard for you to find an available accommodation with reasonable
              price nearby the venue hotel, the secretariat offers our
              participants a reservation service.
              <br />
              3. We highly recommend our participants make your reservation ASAP
              before July 9th 23:59:59 GMT+8! It is very convenient for you to
              attend our technical/social acitvities during the confenerce.
              <br />
              4. We provide an official WeChat group for participants to
              communicate, if you are looking for a roommate during conference,
              please scan the following QR code.
              <br />
              <p align="center">
                <img src="./wechat.jpg" alt="" width="200px" />
              </p>
            </p> */}

            <div className="entry-content">
              <h4>About the venue hotel</h4>
              <br></br>
              <p>
              New World Saigon Hotel is ideally situated in the heart of Ho Chi Minh City District 1 amid a bustling
neighborhood of restaurants and entertainment venues, within walking distance to markets, museums and places
of cultural interest. The hotel is located 20 minutes away from Tan Son Nhat International Airport and steps away
from the central bus station, making it a perfect location to explore the city.
New World Saigon Hotel offers 533 guestrooms and suites with multiple event venues, a casual all-day restaurant,
a sophisticated Chinese restaurant and a vibrant lounge for late night enjoyment.
                <br></br>
                <br></br>
                {/* For more information about the hotel, please visit the website: https://www.ihg.com/crowneplaza/hotels/us/en/sanya/syxcc/hoteldetail */}
              </p>

              <h4>Hotel room</h4>
              <div className="row">
                <table>
                  <tr>
                    <td width="50%">
                      <img src="images/xigong/room1.png" />              </td>
                    <td width="50%">
                      <img src="images/xigong/room3.png" />              </td>
                    {/* <td width="50%">
                      <img src="images/sanya/accom8.png" />              </td> */}
                  </tr>
                </table>
              </div>
              <div className="row">
                <table>
                  <tr>
                    <td width="50%">
                      <img src="images/xigong/room2.png" />              </td>
                    <td width="50%">
                      <img src="images/xigong/room4.png" />              </td>
                    {/* <td width="50%">
                      <img src="images/sanya/accom8.png" />              </td> */}
                  </tr>
                </table>
              </div>

              <h4>
                Restaurant
              </h4>

              <br></br>
              <h5>
              Residence Club Living Room
              </h5>

              <div className="row">
                <table>
                  <tr>
                    <td width="50%">
                      <img src="images/xigong/res1.png" />
                    </td>
                    <td width="50%">
                      <img src="images/xigong/res2.png" />
                    </td>
                  </tr>
                </table>
              </div>
              {/* <div className="row">
                <table>
                  <tr>
                    <td width="50%">
                      <img src="images/xigong/res3.png" />
                    </td>
                    <td width="100%">
                      <img src="images/xigong/res4.png" />
                    </td>
                  </tr>
                </table>
              </div> */}


              <h4>
              INDOCHINE BALLROOM
              </h4>

              <br></br>
              <img src="images/xigong/hall1.png" />
              <img src="images/xigong/hall2.png" />
              {/* <div className="row">
                <table>
                  <tr>
                    <td width="50%">
                      <img src="images/xigong/accom7.png" />
                    </td>
                    <td width="50%">
                      <img src="images/xigong/accom9.png" />
                    </td>
                  </tr>

                </table>



              </div> */}


              <br></br>
              <h4>
                <b>
                  More about accommodation: visit the  <a href="https://saigon.newworldhotels.com/en/">website</a>.
                </b>
              </h4>
            </div>
          </div>
        </EmptyTwo>
        {/* <AboutFive />
              <TestimonialContainer classOption="bg-primary-blue" />
              <CallToActionTwo /> */}
        <Footer />
        <ScrollToTop />
      </React.Fragment >
    );
  }
  else {
    return (
      <React.Fragment>
        <SEO title="Accommodation | DMBD 2025" />
        <Header />
        <Breadcrumb
          image="images/bg/banner2.jpg"
          title="Accommodation"
          content="For Participants"
          contentTwo="Accommodation"
          linkage="/"

        />

        {/* <HomeAbout /> */}
        <EmptyTwo>
          <div>
            <h3>To be released.</h3>
          </div>
        </EmptyTwo>
        {/* <AboutFive />
              <TestimonialContainer classOption="bg-primary-blue" />
              <CallToActionTwo /> */}
        <Footer />
        <ScrollToTop />
      </React.Fragment>
    );
  }
};

export default Accommodation;
